import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software-manage-workflow-menu-item.display-text',
		defaultMessage: 'Manage workflow',
		description: 'Title for menu item in JSW meatball menu',
	},
});
